import endpoints from 'config/endpoints';
import {AWSSUPPORT_TYPES} from 'config/constants/awsSupport';

import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import {TIMEOUT_STORE} from 'util/constants';

const
    mapFields = {
        account_id:     'accountId',
        contact_method: 'contactMethod',
        service_code:   'serviceCode',
        category_code:  'categoryCode'
    },
    transformEntitiesFn = ticket => ({
        id:           ticket.id,
        cc:           ticket.cc,
        subject:      ticket.subject,
        description:  ticket.description,
        attachments:  ticket.attachments,
        accountId:    ticket.account.id,
        severityCode: ticket.severity.code,
        type:         {
            selected: AWSSUPPORT_TYPES.AWSSUPPORT_TYPE_BILLING,
            values:   {
                serviceCode:  ticket.service.code,
                categoryCode: ticket.category.code
            }
        }
    }),
    transformEntitiesToSaveFn = ticket => ({
        cc:          ticket.cc,
        subject:     ticket.subject,
        description: ticket.description,
        attachments: ticket.attachments.map(item => ({
            file_name: item.name,
            hash:      item.hash
        })),
        account_id:    ticket.accountId,
        severity_code: ticket.severityCode,
        service_code:  ticket.type.serviceCode,
        category_code: ticket.type.categoryCode
    });

const exports = storeModuleFactory({
    name:             'awsSupportBilling',
    endpoint:         endpoints.awsSupport.billing.endpoint,
    instanceEndpoint: endpoints.awsSupport.billing.instanceEndpoint,
    /*
    callbackActions:  [{
        method: 'create',
        action: invalidateAccounts
    },{
        method: 'update',
        action: invalidateAccounts
    }],
*/
    timeout:          TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.mapFields = mapFields;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/awsSupportBilling.js